import { getStyleObjectFromCSS } from '@lexical/selection';
import { $getRoot } from 'lexical';
import { LexicalEditor } from 'lexical/LexicalEditor';
import { CharStyleValue } from 'const';
import { getHash, getNormalizedFontFamilies } from 'utils/fontHashes';
import { FontPluginStyle } from '../Plugins/FontPlugin/style';

const IS_BOLD = 0b1;
const IS_ITALIC = 0b10;

const getFontWeightByFormat = (format: number): CharStyleValue =>
  format & IS_BOLD ? CharStyleValue.BOLD : CharStyleValue.REGULAR;

const getFontStyleByFormat = (format: number): CharStyleValue =>
  format & IS_ITALIC ? CharStyleValue.ITALIC : CharStyleValue.NORMAL;

export const getFontHashes = (editorState: LexicalEditor): Set<string> => (
  editorState.read(() => {
    return $getRoot().getAllTextNodes().reduce((acc, item) => {
      const styles = item.getStyle();
      const styleObject = getStyleObjectFromCSS(styles);
      const fontFamily = styleObject[FontPluginStyle.FONT_FAMILY] ?? styleObject[FontPluginStyle.BRAND_FONT_NAME];
      const fontStyle = styleObject[FontPluginStyle.FONT_STYLE];
      const fontWeight = styleObject[FontPluginStyle.FONT_WEIGHT];

      const fonts = fontFamily ? getNormalizedFontFamilies(fontFamily) : [];
      fonts.forEach(font => acc.add(getHash(font, fontWeight, fontStyle)));

      return acc;
    }, new Set<string>());
  })
);

export const getFontHashesForReferenceCitations = (editorState: LexicalEditor, mainFontFamily: string): Set<string> => (
  editorState.read(() => {
    return $getRoot().getAllTextNodes().reduce((acc, item) => {
      const fontStyle = getFontStyleByFormat(item.getFormat());
      const fontWeight = getFontWeightByFormat(item.getFormat());

      return acc.add(getHash(mainFontFamily, fontWeight, fontStyle));
    }, new Set<string>());
  })
);
